import { render } from "./fourohfour.vue?vue&type=template&id=16a796e0&ts=true"
import script from "./fourohfour.vue?vue&type=script&lang=ts"
export * from "./fourohfour.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/brian/VIS Solutions/aeon-boxed-middleware-spa/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__